// extracted by mini-css-extract-plugin
export default {"wrapper":"Tu-z","reviewFormSuccess":"Uu-z","header":"Vu-z","message":"Wu-z","paragraph":"Xu-z","lottieContainer":"Yu-z"};